<template>
  <div>
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver anteriormente</v-btn>
    <h3 class="text-center my-0">Realizar Cambio de Plan</h3>

    <div class="row">
      <div class="col-sm-4">
        <b>Seleccione el nuevo plan de pagos:</b>
        <select class="form-control" v-model="planseleccionado">
          <option :key="ind" v-for="(p, ind) in storagedata.planes" :value="p">{{ p.nombre }} <small v-if="!p.aprobado"> (No aprobado) </small> </option>
        </select>

        <div v-for="(c,ind) in planseleccionado.cobros" :key="ind">
          <b> {{c.nombre}}: </b> <span> {{c.monto}} <small>Bs</small> </span> 
          <b> Cuotas: </b> <span> {{c.cuotas}} </span>
        </div>
      </div>
      <div class="col-sm-6">
        <p class="mb-0"> <b>Programa: </b> <span>{{storagedata.nombre_compuesto}}</span> </p>
        <p class="mb-0"> <b>Estudiante: </b> <span>{{persona.nombres}} {{persona.primer_apellido}} {{persona.segundo_apellido}} </span> <b>Documento: </b> <span>{{persona.numero_documento}} </span> </p>
        <p class="mb-0"> <b>Cel: </b> <span>{{persona.telefono1}} </span> </p>
      </div>
    </div>

    <div class="text-center">
      <div style="display: inline-block;" v-show="loading" class="loader"></div>
    </div>

    <div class="row table-responsive" v-if="!loading">
      <div class="col-sm-6">
        <p class="mb-0 text-center"> <b>Plan de pagos actual del estudiante:</b> </p>
        
        <table class="table table-striped table-hover">
          <thead style="background:#199156;">
            <tr>
              <th style="color:white!important">Cuota</th>
              <th style="color:white!important">Concepto</th>
              <th style="color:white!important">Monto</th>
              <th style="color:white!important">Descuento</th>
              <th style="color:white!important">Saldo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p,ind) in storagedata.plan_pagos" :key="ind" :style="p.monto!=p.saldo?'background:#FFE5E5':''">
              <td> {{p.numero_cuota}} </td>
              <td> {{p.concepto}} </td>
              <td> {{p.monto}} <small>Bs.</small> </td>
              <td> {{p.descuento}} <small>Bs.</small> </td>
              <td> {{p.saldo}} <small>Bs.</small></td>
            </tr>
            <tr v-if="planseleccionado.plan_cobro_programa_id" style="background:#D8E6FF">
              <td></td>
              <td>Total</td>
              <td> {{datospagos.xmontoa}} <small>Bs.</small> </td>
              <td></td>
              <td> {{datospagos.xsaldoa}} <small>Bs.</small> </td>
            </tr>
          </tbody>
        </table>
        <div v-if="planseleccionado.plan_cobro_programa_id">
          <b class="blue--text">NOTA:</b> Total pagado: <b>{{datospagos.totalpagado}}</b> <small>Bs</small>, este monto se descontara al nuevo plan de pagos.
        </div>
      </div>

      <div class="col-sm-6" v-if="valido">
        <p class="mb-0 text-center"> <b>Detalle del nuevo plan: {{planseleccionado.nombre}}</b> </p>
        <table class="table table-striped table-hover">
          <thead style="background:#199156;">
            <tr>
              <th style="color:white!important">Cuota</th>
              <th style="color:white!important">Concepto</th>
              <th style="color:white!important">Monto</th>
              <th style="color:white!important">Saldo</th>
              <th style="color:white!important"> <input type="checkbox" v-model="autofechas"> Fecha pago</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p,ind) in nuevoplan" :key="ind" :style="p.cuota_id?'background:#FFE5E5':''">
              <td> {{p.nro_cuota}} </td>
              <td> {{p.xconcepto}} </td>
              <td> {{p.monto}} <small>Bs.</small> </td>
              <td> {{p.xsaldo}} <small>Bs.</small></td>
              <td> <input type="date" :disabled="p.cuota_id" v-model="p.xfecha" @change="lafechacambia(p)"> </td>
            </tr>
            <tr v-if="planseleccionado.plan_cobro_programa_id" style="background:#D8E6FF">
              <td></td>
              <td>Total</td>
              <td> {{datospagos.xmontob}} <small>Bs.</small> </td>
              <td> {{datospagos.xsaldob}} <small>Bs.</small> </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div v-if="planseleccionado.plan_cobro_programa_id">
          <b class="blue--text">NOTA:</b> Se han descontado: <b>{{datospagos.totalpagado}}</b> <small>Bs</small>, 
          el total a pagar para el nuevo plan es: <b>{{datospagos.xsaldob}}</b> <small>Bs</small>.
        </div>
      </div>
      <div class="col-sm-6" v-else>
        <p class="text-center red--text pa-4"> {{valido?'':msgerr?msgerr:'El cambio de plan no esta disponible para este Plan'}} </p>
      </div>
    </div>

    <div v-if="planseleccionado.plan_cobro_programa_id" class="mt-12">
      <div class="text-center">
        <div style="display: inline-block;" v-show="loading2" class="loader"></div>
      </div>
      <p class="text-center red--text mt-0 mb-0"> <b> {{msg}} </b> </p>
      <!-- <p class="text-center red--text mt-0 mb-0"> <b> {{valido?'':msgerr?msgerr:'El cambio de plan no esta disponible para este Plan'}} </b> </p> -->
      <div class="text-center">
        <button :disabled="(!planseleccionado.plan_cobro_programa_id || loading2) || !valido" class="btn btn-azul pt-2 pb-2" @click="preenvio()">
          <span class="glyphicon glyphicon-share"></span> Realizar el cambio de plan
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import {getheadersrest} from '@/components/Utils';
import xaxios from '@/xaxios';

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      loading2: false,
      valido: true,
      msg: '',
      msgerr: '',
      autofechas: true,
      datospagos: {
        totalpagado:0,
        totalporpagar:0,
        xmontoa:0,
        xsaldoa:0,
        xmontob:0,
        xsaldob:0
      },
      planseleccionado:{plan_cobro_programa_id:''},
      storagedata:{},
      persona:{},
      nuevoplan:[],
    };
  },
  watch:{
    'planseleccionado.plan_cobro_programa_id':function(){
      this.msg = '';
      this.msgerr = '';
      this.valido = true;
      if( !this.planseleccionado.aprobado ){
        this.mostrarerrorplannovalido();
        return;
      }
      this.generaciondelnuevoplan( this.storagedata.plan_pagos,this.planseleccionado.cobros );
    }
  },
  methods: {
    mostrarerrorplannovalido(){
      this.valido = false;
      this.msgerr = 'El plan seleccionado no esta aprobado.';
    },
    getprogramarest() {
      //window.console.log('resultado: ');
      this.loading = true;
      const vue = this;
      let idprograma = this.storagedata.id;
      let estudianteid = this.storagedata.estudiante.id;
      let myHeaders = getheadersrest();
      var requestOptions = { method: 'GET', redirect: 'follow', headers: myHeaders};
      let urlacademico = process.env.VUE_APP_API_REST + `/esam/programa/id/${idprograma}`;
      let urlnopagos = process.env.VUE_APP_API_REST+`/api/esam/inscripcion/estudiante/id/${estudianteid}`;
      let urlpersona = process.env.VUE_APP_API_REST+`/esam/persona/id/${estudianteid}`;
      const solicitudes = [];
      solicitudes.push( fetch(urlacademico, requestOptions) );
      solicitudes.push( fetch(urlnopagos, requestOptions) );
      solicitudes.push( fetch(urlpersona, requestOptions) );

      Promise.all( solicitudes ).then(function (responses) {
        return Promise.all(responses.map(function (response) { return response.json(); }));
      }).then(function (result) {
        let prog = result[1].find( x => x.programa_id == idprograma );
        //window.console.log('resultado: ',result,'\nProgr:',prog);
        vue.persona = result[2].persona;
        if( prog ) {
          let planes = prog.plan_pagos.filter( x => {return x.estado == true } );
          //window.console.log( planes );
          planes.sort( (a,b) => {
            let aux = 0;
            if( a.numero_cuota < b.numero_cuota ) aux = -1
            else if( a.numero_cuota > b.numero_cuota ) aux = 1;
            return aux;
          });
          planes.sort( (a,b) => {
            let aux = 0;
            if( a.concepto_pago_id < b.concepto_pago_id ) aux = -1
            else if( a.concepto_pago_id > b.concepto_pago_id ) aux = 1;
            return aux;
          });
          vue.storagedata.plan_pagos = planes;
        }
        else vue.storagedata.plan_pagos = [];
        vue.loading = false;  
      }).catch( error => {
        window.console.log('error>>', error);
        vue.loading = false;
      });
    },
    lafechacambia( p ){
      if( !this.autofechas ) return;
      var cantidad = 0;
      var indiceactual = 0;
      this.nuevoplan.forEach(function(e){
        if( e.xid == p.xid ) indiceactual = cantidad;
        if( !e.cuota_id ) cantidad++;
      });

      var fs = p.xfecha.split('-');
      // window.console.log( fs );
      var date = new Date( `${fs[0]}/${fs[1]}/${fs[2]}` );
      date.setMonth( date.getMonth() - indiceactual );
      var newfs = [];
      for( let i = 1; i <= cantidad;i++){
        let d = date.getDate();
        let m = date.getMonth()+1;
        let a = date.getFullYear();
        if( d < 10 ) d = '0'+d;
        if( m < 10 ) m = '0'+m;
        date.setMonth( date.getMonth() + 1 );
        newfs.push( `${a}-${m}-${d}` );
      }

      var xind = 0;
      this.nuevoplan.forEach(function(e){
        if( !e.cuota_id ){
          let f = newfs[xind];
          let fs = f.split('-');
          e.xfecha = f;
          e.fecha_pago = `${fs[2]}/${fs[1]}/${fs[0]}`;
          xind += 1;
        }
      });
    },
    generaciondelnuevoplan( antiguo,ordenconceptosx ){
      const ordenconceptos = JSON.parse( JSON.stringify(ordenconceptosx) );
      window.console.log( '>>>\nconst antiguo = ',JSON.stringify(antiguo,null,4),';\n\nconst ordenconceptos = ',JSON.stringify(ordenconceptos,null,4) )
      this.nuevoplan = [];
      const vue = this;
      vue.datospagos.totalpagado = 0;
      vue.datospagos.totalporpagar = 0;
      vue.datospagos.xmontoa = 0;
      vue.datospagos.xsaldoa = 0;
      vue.datospagos.xmontob = 0;
      vue.datospagos.xsaldob = 0;

      const xplanes = [];
      var xindice = 0;
      var date = new Date();
      let day = date.getDate();
      let month = date.getMonth()+1;
      let year = date.getFullYear();
      if( day < 10 ) day = '0'+day;
      if( month < 10 ) month = '0'+month;
      let xfecha = `${year}-${month}-${day}`;
      let fechax = `${day}/${month}/${year}`;

      antiguo.forEach(function(e){
        let concepto = ordenconceptos.find( x => x.concepto_id == e.concepto_pago_id );
          //window.console.log('SALDDDD:',e.monto,e.descuento,e.saldo)
        if( !concepto ){
          if( (e.monto - e.descuento != e.saldo) || e.saldo == 0 ){
            let fs = e.fecha_pago.split('-');
            let fe = `${fs[2]}/${fs[1]}/${fs[0]}`;
            concepto = { cuota_id:e.id,cobro_programa_id: -1, monto: e.monto, nro_cuota: 1, fecha_pago:fe, xconcepto:e.concepto,xfecha:e.fecha_pago,xsaldo:e.saldo,xid: xindice++ };
            vue.valido = false;
            vue.msgerr = `Error: No se puede realizar el cambio de plan, hay un concepto (${e.concepto}: ${e.monto}Bs.), que ya fue cancelado en el plan actual del estudiante, pero este concepto (${e.concepto}) no esta disponible en el nuevo plan seleccionado.`;
            vue.datospagos.totalpagado += (e.monto-e.descuento) - e.saldo;
            vue.datospagos.xmontoa += e.monto;
            vue.datospagos.xsaldoa += e.saldo;
            xplanes.push( concepto );
          }
        }else{
          if( !concepto.antiguos ) concepto.antiguos = [];
          vue.datospagos.totalpagado += (e.monto-e.descuento) - e.saldo;
          vue.datospagos.xmontoa += e.monto;
          vue.datospagos.xsaldoa += e.saldo;
          if( (e.monto - e.descuento != e.saldo) || e.saldo == 0 ) {
            concepto.monto -= e.monto;
            concepto.antiguos.push( e );
          }
        }
      });

      ordenconceptos.forEach(function(e){
        if( !e.antiguos ) e.antiguos = [];
        let numerocuota = 1;

        //window.console.log( '>>>',e.antiguos ) cuota_id

        /*e.antiguos.sort( (a,b) => {
          let aux = 0;
          if( a.numero_cuota < b.numero_cuota ) aux = -1
          else if( a.numero_cuota > b.numero_cuota ) aux = 1;
          return aux;
        })*/

        e.antiguos.forEach( a => {
          numerocuota = a.numero_cuota;
          let fs = [];
          let fe = '';
          if( !a.fecha_pago ){ // FIX
            let ff = a.fecha_registro.split(' ');
            fs = ff[0].split('-');
            fe = `${fs[2]}/${fs[1]}/${fs[0]}`;
            a.fecha_pago = `${fs[0]}-${fs[1]}-${fs[2]}`;
          }else{
            fs = a.fecha_pago.split('-');
            fe = `${fs[2]}/${fs[1]}/${fs[0]}`;
          }
          let concepto = { cuota_id:a.id,cobro_programa_id: e.cobro_programa_id, monto: a.monto, nro_cuota: numerocuota, fecha_pago:fe, xconcepto:a.concepto,xfecha:a.fecha_pago,xsaldo:a.saldo,xid: xindice++ };
          xplanes.push( concepto );
          vue.datospagos.xmontob += a.monto;
          vue.datospagos.xsaldob += a.saldo;
          numerocuota += 1;
        });
        let restantescuotas = e.cuotas - e.antiguos.length;
        let xmontito = Math.round( e.monto / restantescuotas );
        let xsobra = e.monto - (xmontito * restantescuotas);

        if( restantescuotas > 0 ){
          for( let i = 0; i < restantescuotas; i++ ){
            let concepto = { cobro_programa_id: e.cobro_programa_id, monto: xmontito, nro_cuota: numerocuota, fecha_pago:fechax, xconcepto:e.nombre,xfecha:xfecha,xsaldo:xmontito,xid: xindice++ };
            if( i == 0 ) {
              concepto.monto += xsobra;
              concepto.xsaldo += xsobra;
            }
            if( concepto.monto < 0 ){
              vue.valido = false;
              vue.msgerr = `Error: El un concepto (${e.nombre}), tiene un monto pagado mayor al del nuevo plan seleccionado.`;
            }else if( concepto.monto > 0 ){
              xplanes.push( concepto );
              vue.datospagos.xmontob += concepto.monto;
              vue.datospagos.xsaldob += concepto.xsaldo;
              numerocuota += 1;
            }
          }
        }else if( e.monto > 0 ){
          let concepto = { cobro_programa_id: e.cobro_programa_id, monto: e.monto, nro_cuota: numerocuota, fecha_pago:fechax, xconcepto:e.nombre,xfecha:xfecha,xsaldo:e.monto,xid: xindice++ };
          if( concepto.monto < 0 ){
            vue.valido = false;
            vue.msgerr = `Error: El concepto (${e.nombre}), que tiene un monto pagado mayor al del nuevo plan seleccionado.`;
          }else{
            xplanes.push( concepto );
          }
        }
      });

      let primeroeditable = xplanes.find( x => x.cuota_id == null );
      this.nuevoplan = xplanes;
      //window.console.log('XNUEVO:',JSON.stringify(xplanes,null,4))
      vue.lafechacambia( primeroeditable );
      //window.console.log( 'PLAN:\n',primeroeditable,JSON.stringify(this.nuevoplan,null,4) );
    },
    preenvio(){
      const vue = this;
      this.msg = '';
      let men = `<b class='text-danger'>Importante:</b><br/><br/>Antes de continuar con el cambio de plan, revise que todas las 
      <b class='text-primary'>fechas previstas de pago</b>,
      estan correctamente ingresadas, es su responsabilidad asegurarse de guardar informacion fidedigna.<br/><br/> Si esta seguro que todos los datos estan correctos puede continuar.`;
      this.$dialog.confirm( men ).then(function () {
        vue.enviarnuevoplan();
        }).catch(function () {
          vue.loading2 = false;
        });
    },
    enviarnuevoplan(){
      const vue = this;
      vue.loading2 = true;
      let myHeaders = getheadersrest();
      const data = {
        "inscripcion_id": this.storagedata.xprog.inscripcion_id,
        "programa_id": this.storagedata.programa.id,
        "estudiante_id": this.storagedata.estudiante.id,
        "observaciones": "Se ha realizado un cambio de plan",
        "asesor_id": this.storagedata.asesor.id,
        "registrado_por": this.storagedata.asesor.id, // en duda, ero no tengo este dato
        "tipo_pago": true,       
        "plan_cobro_programa_id": this.planseleccionado.plan_cobro_programa_id,
        "plan_pagos": this.nuevoplan
      };
      var raw = JSON.stringify(data, null, 4);
      var requestOptions = { method: 'PUT', headers: myHeaders, body: raw };
      window.console.log( 'NUEVO PLAN:\n',raw );
      
      let urlacademico = process.env.VUE_APP_API_REST + `/api/esam/inscripcion/change/plan`;
      //window.console.log( urlacademico );
      fetch(urlacademico, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          window.console.log('CAMBIO_PLAN:',result);
          if (!result) {
            vue.msg = 'ERROR DESCONOCIDO, NO SE PUDO Generar el plan.';
          } else if (result.error) {
            vue.msg = result.error;
          } else {
            this.$root.$notify.show(`Nuevo Plan Asignado correctamente`, { color: 'success', x: 'left' });
            if (result.enrollment_id) {
              vue.msg = 'plan generado exitosamente, ID: ' + result.enrollment_id;
              sessionStorage.removeItem('xpreinscrito');
              sessionStorage.removeItem('xinscritotoplan');
              vue.$router.back();
            } else if (result.result) {
              vue.msg = 'plan generado exitosamente.';
              sessionStorage.removeItem('xpreinscrito');
              sessionStorage.removeItem('xinscritotoplan');
              vue.$router.back();
            } else {
              vue.msg = 'ERROR: ' + result;
            }
          }
          vue.loading2 = false;
        })
        .catch(() => {
          this.$root.$notify.show(`Ocurrio un error`, { color: 'red', x: 'left' });
          vue.loading2 = false;
        });
    },

    getprogramabyid(id) {
      this.loading = true;
      xaxios
        .get(`${process.env.VUE_APP_API_REST}/esam/programa/id/${id}`)
        .then(async ({ data }) => {
          this.loading = false;
          if (!data.responsable) data.responsable = {};
          if (!data.coordinador) data.coordinador = {};
          let p = data;
          p.plan_pagos = [];
          this.storagedata.planes = p.planes.filter( x => {return x.estado} );
          //this.storagedata = p;
          this.getprogramarest();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    let generarplaninscrito = sessionStorage.getItem('xinscritotoplan');
    let xprograma = sessionStorage.getItem('xprograma');
    let xprog = JSON.parse(xprograma);
    // window.console.log('generarplaninscrito>', generarplaninscrito)
    let p = JSON.parse(generarplaninscrito);
    p.plan_pagos = [];
    if( !p.planes ) p.planes = [];
    window.console.log('generarplaninscrito>', p.planes,p)
    this.getprogramabyid(p.id);
    // Filtrar solo los planes activos
    p.planes = p.planes.filter( x => {return x.estado} );
    p.xprog = xprog;
    this.storagedata = p;
    //window.console.log( '>',this.storagedata );
    //this.getprogramarest();
  },
};
</script>
